import { ButtonProps } from 'antd';
import { MessageSendIcon } from 'common/icons';
import { ComponentType } from 'react';
import { AIGradientColors, NeutralColors } from 'src/theme/colors';

interface CropwiseAiInputSuffixProps {
  components: {
    SendButton: ComponentType<ButtonProps>;
    LoadingButton: ComponentType<ButtonProps>;
    SpeechButton: ComponentType<ButtonProps>;
  };
  isPending: boolean;
  value: string;
}

const CropwiseAiInputSuffix = ({
  components,
  isPending,
  value,
}: CropwiseAiInputSuffixProps) => {
  const { SendButton, LoadingButton, SpeechButton } = components;

  if (isPending) {
    return <LoadingButton />;
  }

  if (!value.trim()) {
    return (
      <SpeechButton
        style={{
          border: 'none',
          background: AIGradientColors[60],
          borderRadius: '50%',
          width: 32,
          height: 32,
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'background 0.5s, border 0.5s',
          color: NeutralColors[0],
        }}
      />
    );
  }

  return (
    <SendButton
      icon={
        <MessageSendIcon
          style={{
            fill: NeutralColors[0],
            transition: 'fill 0.5s',
          }}
        />
      }
      style={{
        border: 'none',
        background: AIGradientColors[60],
        borderRadius: '50%',
        width: 32,
        height: 32,
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'background 0.5s, border 0.5s',
      }}
    />
  );
};

export { CropwiseAiInputSuffix };
